export default __webpack_public_path__ + "static/media/android_step_2_En.0ec4526f.jpg";